import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import { useDispatch, useSelector } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import { Card, CardContent } from '@material-ui/core';
import useStyles from './differentSourceStyle';
import './differentStyles.css';
import SalaryDifferentSource from './salary';
import HousePropertyDifferent from './houseproperty';
import BusinessDifferent from './business';
import CapitalGainDifferent from './capitalgain';
import OtherSourcesDifferent from './othersources';
import AgricultureIncomeDifferent from './agricultureincome';
import Deductions from './deductions';
import { CommonConfig } from '../../../../config/common-config';
import { cacheservice } from '../../../../config/cacheservice';
import { userType } from '../../../../config/usertypeValue';
import LoaderPopUp from '../../../../components/loaderpopup/loader';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function DifferentSource(props) {
    const dispatch = useDispatch({});
    const tabRef = useRef();
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [checklist, setChecklist] = useState('');
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const checklist1que = checklist1 && checklist1.questions;
    let salaryradiodata = (checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[0].response) || 'Yes';
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const [value, setValue] = React.useState(0);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const [showLoader, setShowLoader] = useState(false);
    const [relevanceList, setRelevanceList] = useState([
        { color: '#3ccbcb', name: 'Relevant' },
        { color: '#db466b', name: 'Irrelevant' },
        { color: '#FFC300', name: 'Partially Relevant' },
    ]);

    let subscription;
    let radiovalue;
    // const [checklistID, setChecklistID] = useState('');
    const statusIDValue = useSelector((state) => state.serviceCheckListReducer.selectedStageId);

    const handleChange = (event, newValue) => {
        setShowLoader(true);

        console.log('tabssss');
        setTimeout(() => {
            setShowLoader(false);
        }, 3000);
        setValue(newValue);
    };

    const handleTabChange = (tabValue) => {
        scrollTop();
        setValue(tabValue);
    };

    const scrollTop = () => {
        tabRef.current.scrollIntoView();
    };

    useEffect(() => {
        // subscribe to home component messages

        subscription = cacheservice.getMessage().subscribe((message) => {
            userType.deductionFlag = false;
            if (message.text === 'Yes') {
                salaryradiodata = 'Yes';
                userType.deductionValue = 'Yes';
            }
            if (message.text === 'No') {
                salaryradiodata = 'No';
                userType.deductionValue = 'No';
            }
        });
        const bearerToken = `Bearer ${userToken}`;


        if (userType.historyStageId <= statusIDValue) {
            //console.log('history view')
            setShowLoader(true);
            axios
                .get(
                    `${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${
                    usertype === 'Ultimate Client' || usertype === 'EM' ? tennantnameValue : imcNameSelected
                    }/${serviceIdValue}/${userType.historyStageId}`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    setShowLoader(false);
                    let tempObj = response.data;
                    tempObj['checklistJson'] = JSON.parse(response.data.checklistJson);
                    //console.log('JSON.parse(response.data)', tempObj)
                    // setChecklistID(tempObj);
                    setChecklist(tempObj);
                })
                .catch((error) => {
                    setShowLoader(false);
                });
        } else {
            setShowLoader(true);
            axios
                .get(
                    `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                    usertype === 'Ultimate Client' || usertype === 'EM' ? tennantnameValue : imcNameSelected
                    }/${serviceIdValue}`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    setShowLoader(false);
                    setChecklist(response.data);
                })
                .catch((error) => {
                    setShowLoader(false);
                });
        }
    }, [userToken, salaryradiodata]);

    //console.log("salaryradiodata", salaryradiodata);

    const handleClose = () => {
        setShowLoader(false);
    };

    return (
        <div className="main-container">
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
            <Card className="client-card">
                <CardContent className="client-heading" ref={tabRef}>
                    <Typography variant="h5">What are the different sources of income that you have?</Typography>
                </CardContent>
                <CardContent>
                    {/* {checklist && checklist.currentStage && checklist.currentStage.id !== 2 ? (
                        <span>
                            <div style={{ marginLeft: '12px', display: 'flex', placeContent: 'flex-end' }}>
                                {relevanceList &&
                                    relevanceList.map((user) => (
                                        // <ul className={classes.relevenceDisplay}>
                                        //     <li>
                                        <span style={{ display: 'flex', marginLeft: '20px', alignItems: 'center' }}>
                                            <div style={{ background: user.color, width: '16px', height: '15px' }}></div>
                                            <div style={{ marginLeft: '6px' }}>{user.name}</div>
                                        </span>
                                        //     </li>
                                        // </ul>
                                    ))}
                            </div>
                        </span>
                    ) : ''} */}
                    <AppBar position="static" color="default" className="custom-tab">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                        >
                            <Tab label="Salary" {...a11yProps(0)} />
                            <Tab label="House Property" {...a11yProps(1)} />
                            <Tab label="Business or Profession" {...a11yProps(2)} />
                            <Tab label="Capital Gain" {...a11yProps(3)} />
                            <Tab label="Other Sources" {...a11yProps(4)} />
                            <Tab label="Agricultural Income" {...a11yProps(5)} />
                            {userType.deductionFlag && salaryradiodata === 'No' ? <Tab label="Deductions" {...a11yProps(6)} /> : ''}
                            {!userType.deductionFlag && userType.deductionValue === 'No' ? (
                                <Tab label="Deductions" {...a11yProps(6)} />
                            ) : (
                                    ''
                                )}
                        </Tabs>
                    </AppBar>
                    <CardContent>
                        <TabPanel value={value} index={0}>
                            <SalaryDifferentSource
                                StyledRadio={StyledRadio}
                                handleTabChange={handleTabChange}
                                handlePageChange={props.handlePageChange}
                            />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <HousePropertyDifferent StyledRadio={StyledRadio} handleTabChange={handleTabChange} />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <BusinessDifferent StyledRadio={StyledRadio} handleTabChange={handleTabChange} />
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <CapitalGainDifferent handleTabChange={handleTabChange} />
                        </TabPanel>
                        <TabPanel value={value} index={4}>
                            <OtherSourcesDifferent handleTabChange={handleTabChange} />
                        </TabPanel>
                        <TabPanel value={value} index={5}>
                            <AgricultureIncomeDifferent handlePageChange={props.handlePageChange} handleTabChange={handleTabChange} />
                        </TabPanel>
                        {userType.deductionFlag && salaryradiodata === 'No' ? (
                            <TabPanel value={value} index={6}>
                                <Deductions
                                    StyledRadio={StyledRadio}
                                    handleTabChange={handleTabChange}
                                    handlePageChange={props.handlePageChange}
                                />
                            </TabPanel>
                        ) : (
                                ''
                            )}
                        {!userType.deductionFlag && userType.deductionValue === 'No' ? (
                            <TabPanel value={value} index={6}>
                                <Deductions
                                    StyledRadio={StyledRadio}
                                    handleTabChange={handleTabChange}
                                    handlePageChange={props.handlePageChange}
                                />
                            </TabPanel>
                        ) : (
                                ''
                            )}
                    </CardContent>
                </CardContent>
            </Card>
        </div>
    );
}
